import { createStyleSheet } from 'Components/foundation/stylesheets';

export default createStyleSheet({
  omnibox: {
    marginTop: 7,
    marginBottom: 47,
  },
});
